import { distance } from "chroma-js";
import PptxGenJS from "pptxgenjs";

export function makePowerpoint(data) {

    let { mapUrls, propertyName, driveTime, gaugeUrls, gaugeDimensions, socialImpactUrl, subscoreUrl, subscoreDimensions, socialImpactDimensions } = data

    function percentHeight(width, height, percentWidth) {
        let hwRatio = height / width
        let percentHeight = (16/9) * percentWidth * hwRatio
        return percentHeight
    }

    /* calculating coordinates for placing elements in the powerpoint
    the units in the calculations are all percents */

    let margin = 5;

    let climateMap = {}
    climateMap.x = 4 * margin
    climateMap.y = 13
    climateMap.w = 30 - (2 * margin)
    climateMap.h  = climateMap.w * 16/9 //we want the map to be square, these are percents, and the aspect ratio is 16:9, so the height needs to be proportionally larger
    //we know it's 16:9 because that's the default for the powerpoint generator, we could have set it to something else if we wanted
    climateMap.centerX = climateMap.x + climateMap.w/2

    let header = {}
    header.w = 100
    header.x = 0
    header.y = 0
    header.h = climateMap.y - margin/2

    let title = {}
    title.x = 2
    title.y = margin * 0.7

    let subtitle = {}
    subtitle.x = title.x
    subtitle.y = 1.6 * margin

    let climateTitle = {}
    climateTitle.y = climateMap.y + climateMap.h + margin
    climateTitle.centerX = climateMap.centerX
    climateTitle.w = 20
    climateTitle.x = climateTitle.centerX - climateTitle.w/2

    let risqGauge = {}
    let unscaledRisqWidth = gaugeDimensions.risq.width
    let unscaledRisqHeight = gaugeDimensions.risq.height

    //on a square canvas, we'd have w/h = ratio
    // but instead 100/100 scales to 16/9
    //so I think we should have w/h = 16/9 * ratio
    // so h = w /ratio * 9/16


    risqGauge.centerX = climateMap.centerX
    risqGauge.w= 15
    risqGauge.h = percentHeight(unscaledRisqWidth, unscaledRisqHeight, risqGauge.w)
    risqGauge.y = climateTitle.y + (0.75 * margin)
    risqGauge.x = risqGauge.centerX - risqGauge.w/2

    let subscoreGauge = {}
    subscoreGauge.y = risqGauge.y + risqGauge.h + margin/2
    let unscaledSubscoreWidth = gaugeDimensions.hurricane.width //any metric name would do, they're all the same
    let unscaledSubscoreHeight = gaugeDimensions.hurricane.height


    subscoreGauge.w = 10
    subscoreGauge.h = percentHeight(unscaledSubscoreWidth, unscaledSubscoreHeight, subscoreGauge.w)

    /*there are three subscore gauges, with x coordinate dependent on the gauge, stored at subscoreGauge.x[index] */
    let indices = [0, 1, 2];
    subscoreGauge.x = {}
    indices.forEach(index =>{
            let subscoreGaugeX = risqGauge.centerX - subscoreGauge.w/2 + (index - 1) * 12
            subscoreGauge.x[index] = subscoreGaugeX
        }
    )

    let socialMap = {}
    let distanceBetweenMaps = 100 - (2 * climateMap.w) - (2 * climateMap.x)
    socialMap.x = 50
    + (distanceBetweenMaps/2)
    socialMap.centerX = socialMap.x + climateMap.w/2
    socialMap.y = climateMap.y
    socialMap.w = climateMap.w
    socialMap.h = climateMap.h

    let socialTitle = {}
    socialTitle.y = climateTitle.y
    socialTitle.w = climateTitle.w
    socialTitle.x = socialMap.centerX - socialTitle.w/2

    let socialImpactChart = {}

    socialImpactChart.y = risqGauge.y;
    socialImpactChart.x = 55
    socialImpactChart.w = 15
    socialImpactChart.h = percentHeight(socialImpactDimensions.width, socialImpactDimensions.height, socialImpactChart.w)
    console.log(socialImpactChart.w, socialImpactChart.h)

    let subscoreChart = {}
    subscoreChart.y = socialImpactChart.y
    subscoreChart.x = socialImpactChart.x + socialImpactChart.w + margin/2
    subscoreChart.w = 20
    subscoreChart.h = percentHeight(subscoreDimensions.width, subscoreDimensions.height, subscoreChart.w)

    /* apply to both climate and social titles */
    let titleOptions = {
        fontSize: 12,
        color: '000000',
        fontFace: 'Arial Black',
        align: 'center'
    }

    //leaving out subscoreGauge because this has a different structure (with nested {x: {index: number}}) - we'll convert this to percents separately
    let elements = [header, title, subtitle, climateMap, socialMap, risqGauge, socialImpactChart, subscoreChart, climateTitle, socialTitle]

    let percent = (number) => number.toString().concat('%')

    //convert all element options to percent
    elements.forEach(element => {
        Object.keys(element).forEach(key => {
            element[key] = percent(element[key])
        })
    })

    /* build the presentation */
    let presentation = new PptxGenJS();
    presentation.theme = { bodyFontFace: "Arial", headFontFace: "Arial" }; //these should be global font settings but don't seem to actually apply, so I'm manually adding fontFace props to all text elements too
    let slide = presentation.addSlide();

    slide.addShape(presentation.ShapeType.rect, {
        ...header,
        fill: {
            color: '#71C5E8',
            transparency: 20
        }
    });

    slide.addText(`${propertyName}`, {
        ...title,
        color: '000000',
        fontFace: 'Arial Black'
      });


    slide.addText(`Drive time: ${driveTime} min`, {
        ...subtitle,
        color: '000000',
        fontSize: 10,
        fontFace: 'Arial Black'
    })

    slide.addImage({
        ...climateMap,
        data: mapUrls.climate,
    })

    slide.addImage({
        ...socialMap,
        data: mapUrls.social,
    })

    slide.addText(`Climate Summary`, {
        ...climateTitle,//specific options for climate title
        ...titleOptions,//general options for both climate and social title
    })

    //gaugeUrls are an object, with category as key
    Object.keys(gaugeUrls).forEach((key, index) => {
        if(key === 'risq') {
            slide.addImage({
                ...risqGauge,
                // w: unscaledRisqWidth,
                // h: unscaledRisqHeight,
                data: gaugeUrls[key],
            })
        }
        else {
            /* remember, subscoreGauge is the one options object not converted to percents, so we're doing that separately here */
            slide.addImage({
                data: gaugeUrls[key],
                h: percent(subscoreGauge.h),
                w: percent(subscoreGauge.w),
                y: percent(subscoreGauge.y),
                x: percent(subscoreGauge.x[index]),
                })
            }
    })

    slide.addText('Social Summary', {
        ...socialTitle,//specific social title options
        ...titleOptions//options shared across social and climate title
    })

    slide.addImage({
        ...socialImpactChart,
        data: socialImpactUrl,
    })

    slide.addImage({
        ...subscoreChart,
        data: subscoreUrl,
    })

    /* adding footer */
    slide.addText(
        'CONFIDENTIAL',
        {
            x: '2%',
            y: '96%',
            color: '9A9A9A',
            fontSize: 8,
            fontFace: 'Arial'
        }
    )

    slide.addImage({
        x: '92%',
        y: '92%',
        w: 0.3,
        h: 0.3,
        path: require('@/assets/ICE_logo_rgb.png')
    })

    presentation.writeFile({ fileName: `${propertyName}.pptx`})
}
